import { describeStaffFailure } from "../failure-words";

// How the Operations page tells a staff member what went wrong. No id, key, run reference or detail goes into a message.

export type OperationsFailure = Readonly<{
  message: string;
  /** The page must read again: what the user saw is out of date. */
  reload: boolean;
}>;

const NO_ANSWER = "The service did not answer. Try again.";
const BAD_REQUEST = "The request was not accepted.";
const OTHER = "Something went wrong. Try again.";

export function describeOperationsError(error: unknown): OperationsFailure {
  const { message, reload } = describeStaffFailure(error, {
    forbidden: "Your staff role does not allow this.",
    conflict: "That job changed or already has an open re-run. The list was reloaded.",
    on: {
      unauthenticated: "Your session ended. Sign in again.",
      // A job that is gone is a job that changed: read again.
      not_found: { message: "That job no longer exists. The list was reloaded.", reload: true },
      bad_request: BAD_REQUEST,
      invalid: BAD_REQUEST,
      network: "The service could not be reached. Check the connection and try again.",
      response: "The service answered in a form this page does not know.",
      upload: OTHER,
      other: OTHER,
      unavailable: NO_ANSWER,
      server: NO_ANSWER,
      timeout: NO_ANSWER,
      too_large: NO_ANSWER,
      other_status: NO_ANSWER,
    },
  });
  return { message, reload };
}
